import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconSites } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleSharedBrowser } from '../../actions';
class SharedBrowserButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.sharedBrowser';
    icon = IconSites;
    label = 'toolbar.sharedBrowser';
    toggledLabel = 'toolbar.stopSharedBrowser';
    tooltip = 'toolbar.sharedBrowser';
    _handleClick() {
        this.props.dispatch(toggleSharedBrowser());
    }
    _isToggled() {
        return this.props._isOpen;
    }
}
function mapStateToProps(state) {
    const sharedBrowserState = state['features/shared-browser'];
    return {
        _isOpen: sharedBrowserState?.isOpen
    };
}
export default translate(connect(mapStateToProps)(SharedBrowserButton));
